<template>
  <section :class="(!$store.state.cuenta.session.token) ? 'm-4' : ''">
    <b-overlay
      :show="loader.factura"
      opacity="0.50"
      rounded="sm"
    >
      <validation-observer ref="formCurso">
        <b-card class="blog-edit-wrapper">
          <titleSection
            :title="'Datos de facturación'"
            :subtitle="'Escriba los datos que a continuación se le piden'"
            icon="InfoIcon"
          />
          <b-form
            v-if="datos"
            class="mt-2"
          >
            <b-row>
              <!-- Alias -->
              <b-col md="3">
                <validation-provider
                  #default="{ errors }"
                  name="Alias"
                  rules="required"
                >
                  <b-form-group
                    label="Alias"
                    label-for="helperInput"
                    description="Nombre que se le dara a tu registro para identificarlo más facilmente"
                  >
                    <b-form-input
                      id="register-username"
                      v-model="datos.alias"
                      name="register-username"
                      :state="errors.length > 0 ? false:null"
                      placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  #default="{ errors }"
                  name="Razon"
                  rules="required"
                >
                  <b-form-group
                    label="Razon social"
                    label-for="helperInput"
                    description="Razon social a facturar"
                  >
                    <b-form-input
                      id="register-razon"
                      v-model="datos.razon"
                      name="register-razon"
                      :state="errors.length > 0 ? false:null"
                      placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="3">
                <validation-provider
                  #default="{ errors }"
                  name="Rfc"
                  rules="required|max:15"
                >
                  <b-form-group
                    label="RFC"
                    label-for="helperInput"
                    description="Registro Federal de Contribuyentes"
                  >
                    <b-form-input
                      id="register-username"
                      v-model="datos.rfc"
                      name="register-username"
                      onkeyup="javascript:this.value=this.value.toUpperCase();"
                      :state="errors.length > 0 ? false:null"
                      placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <titleSection
              :title="'Dirección'"
              :subtitle="'Escriba los datos que a continuación se le piden'"
              icon="InfoIcon"
            />
            <b-row class="mt-1">
              <!-- calle  -->
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="Calle"
                  label-for="calle"
                >
                  <b-form-input
                    id="calle"
                    v-model="datos.calle"
                  />
                </b-form-group>
              </b-col>

              <!-- numero  -->
              <b-col
                cols="12"
                md="2"
              >
                <b-form-group
                  label="Número"
                  label-for="numero"
                >
                  <b-form-input
                    id="numero"
                    v-model="datos.numero"
                  />
                </b-form-group>
              </b-col>

              <!-- interior  -->
              <b-col
                cols="12"
                md="2"
              >
                <b-form-group
                  label="Interior"
                  label-for="interior"
                >
                  <b-form-input
                    id="interior"
                    v-model="datos.interior"
                  />
                </b-form-group>
              </b-col>
              <!-- código postal  -->
              <b-col
                cols="12"
                md="2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="código postal"
                  rules="digits:5|required"
                >
                  <b-form-group
                    label="Código postal"
                    label-for="cp"
                  >
                    <b-form-input
                      id="cp"
                      v-model="datos.cp"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <!-- colonia  -->
              <b-col
                cols="6"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="Colonia"
                  label-for="colonia"
                >
                  <b-form-input
                    id="colonia"
                    v-model="datos.colonia"
                  />
                </b-form-group>
              </b-col>
              <!-- municipio -->
              <b-col
                cols="6"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="Municipio"
                  label-for="municipio"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="municipio"
                    rules="required"
                  >
                    <v-select
                      v-model="datos.municipio"
                      placeholder="Búsque su municipio y seleccionelo"
                      label="nombre"
                      :filterable="false"
                      :options="municipios"
                      :clearable="false"
                      @search="onSearch"
                    >
                      <!-- CUANDO NO HAY OPCIONES -->
                      <template #no-options>
                        Teclea al menos 4 letras de tu municipio y seleccionelo
                      </template>
                      <!-- COMO SE VEN LAS OPCIONES -->
                      <template #option="{ nombre }">
                        <span>{{ nombre }}</span>
                      </template>                    <!-- COMO SE VE LA OPCIÓN SELECCIONADA -->
                      <template #selected-option="{ nombre }">
                        <div>
                          <b class="text-primary">{{ nombre }}</b>
                        </div>
                      </template>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <!-- referencia 1  -->
              <b-col
                cols="12"
                md="4"
                lg="4"
              >
                <b-form-group
                  label="Referencia 1"
                  label-for="ref1"
                >
                  <b-form-input
                    id="ref1"
                    v-model="datos.ref1"
                  />
                </b-form-group>
              </b-col>

              <!-- referencia 2  -->
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="Referencia 2"
                  label-for="ref1"
                >
                  <b-form-input
                    id="ref2"
                    v-model="datos.ref2"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
          <!-- Botones de cancelación y guardado -->
          <div class="text-right mt-2">
            <!-- Save changes -->
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-1"
              @click.prevent="validationForm"
            >
              Guardar cambios
            </b-button>
            <!-- Cancel -->
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-danger"
              @click="pathBack()"
            >
              Cancelar
            </b-button>
          </div>
        </b-card>
      </validation-observer>
    </b-overlay>
  </section>
</template>

<script>
import {
  BCard,
  BOverlay,
  BForm,
  BRow,
  BCol,
  BButton,
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { required } from '@validations'
import { useRouter } from '@core/utils/utils'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ref, computed } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import titleSection from '@/views/components/title-section.vue'
import vSelect from 'vue-select'
import { getData } from '@core/utils/http/general'

export default {
  components: {
    titleSection,
    BCard,
    BOverlay,
    BForm,
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    ValidationObserver,
    ValidationProvider,
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    datos: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // FORMS
      selected: { title: 'Square' },
      option: [{ title: 'Square' }, { title: 'Rectangle' }, { title: 'Rombo' }, { title: 'Romboid' }],
    }
  },
  setup(props, { emit }) {
    const toast = useToast()
    const { router } = useRouter() //* Use router propieties
    const formCurso = ref(null)
    const { route } = useRouter() //* Use router propieties
    const { id, persona } = route.value.params //* Get the token from params
    const loader = ref({ factura: false, periodo: false, detalles: false })
    // VUE SELECT
    const municipios = ref([])
    const getValuesToSend = computed(() => {
      const {
        id_fact, alias, razon, rfc, calle, numero, interior, cp, colonia, ref1, ref2, id_direccion, municipio,
      } = props.datos
      const toUpdate = {
        id_fact, alias, razon, rfc, calle, numero, interior, cp, colonia, ref1, ref2, id_direccion, municipio,
      }
      // Si hay id es edición [4], sino nuevo curso [3]
      const dataReturn = {
        task: 'wsfactura', action: 4, datos: JSON.stringify(toUpdate),
      }

      if (id !== 'null') {
        dataReturn.id = id
        if (persona !== 'null') {
          toUpdate.persona = persona
          dataReturn.action = 22
          dataReturn.task = 'wsinscripcion'
          dataReturn.datos = JSON.stringify(toUpdate)
        }
      } else {
        dataReturn.action = 3
        if (persona !== 'null') {
          toUpdate.persona = persona
          dataReturn.action = 21
          dataReturn.task = 'wsinscripcion'
          dataReturn.datos = JSON.stringify(toUpdate)
        }
      }
      return dataReturn
    })

    const saveChanges = () => {
      store.dispatch('cuenta/postDatosFact', getValuesToSend.value)
        .then(response => {
          // loader.value.detalles = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Solicitud exitosa',
              text: response.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          },
          { timeout: 8000 })
          if (id !== 'null') {
            emit('reload-data')
            router.go(-1)
            // router.push('/cuenta')
          } else {
            router.go(-1)
            // router.push('/cuenta')
          }
        }, error => {
          loader.value.detalles = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en petición [Agregar datos de facturacion]',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }
    const pathBack = () => {
      router.go(-1)
    }

    const validationForm = () => {
      formCurso.value.validate().then(success => {
        if (success) saveChanges()
      })
    }

    const onSearch = (search, loading) => {
      if (search.length <= 3) return false // SEARCH IT'S EMPTY OR LESS THAN 4 LETTERS

      loading(true)
      getData({ action: 25, search })
        .then(response => {
          loading(false)
          if (response.status === 200 && response.data.status === 200) {
            municipios.value = response.data.data
            return true
          }
          municipios.value = []
          //! Deprecated
          // this.$bvToast.toast(response.data.message, {
          //   title: `${response.data.status} - Error cargando dependencias`,
          //   variant: 'danger',
          // })
          return false
        })
        .catch(err => {
          loading(false)
          this.$bvToast.toast(err, {
            title: 'Error en solicitud [municipio]',
            variant: 'danger',
          })
        })
      return true
    }

    return {
      formCurso,
      loader,
      getValuesToSend,
      saveChanges,
      validationForm,
      required,
      // functions
      pathBack,
      // vue select
      municipios,
      onSearch,
    }
  },
  methods: {
    registroExitoso() {
      this.$swal({
        title: '<b>Operacion exitosa</b>',
        html: '',
        icon: 'success',
        timer: 10000,
        showConfirmButton: false,
        buttonsStyling: false,
      })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
